import { render, staticRenderFns } from "./WpsOffice.vue?vue&type=template&id=e8a062f4&scoped=true"
import script from "./WpsOffice.vue?vue&type=script&lang=js"
export * from "./WpsOffice.vue?vue&type=script&lang=js"
import style0 from "./WpsOffice.vue?vue&type=style&index=0&id=e8a062f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a062f4",
  null
  
)

export default component.exports